import React, { useEffect, useMemo, useState } from "react";

export default function CoberturaDGUA() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const url = useMemo(() => {
    const payload = {
      Token:
        "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril",
      },
      DatosMetodo: {
        NombreMetodo: "ListaInventarioProductosCoberturaDGUA",
        Datos_Recibidos: JSON.stringify({ DiasProyeccion: 15 }),
        Datos_Generados: "",
      },
    };

    return `https://appcorp.parma.com.gt/apipp/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(payload)
    )}`;
  }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      setError("");

      const resp = await fetch(url, {
        method: "GET",
      });

      if (!resp.ok) {
        throw new Error(`Error HTTP ${resp.status}`);
      }

      const json = await resp.json();

      const datosGenerados =
        json.datos_Generados ||
        json.Datos_Generados ||
        json.datos_generados ||
        "[]";

      const productos = JSON.parse(datosGenerados);

      setData(productos);
    } catch (err) {
      console.error(err);
      setError("No se pudieron cargar los datos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const dataOrdenada = [...data].sort((a, b) => {
    const coberturaA = Number(a.Cobertura_Diario_DGUA || 0);
    const coberturaB = Number(b.Cobertura_Diario_DGUA || 0);

    if (coberturaA !== coberturaB) {
      return coberturaA - coberturaB;
    }

    return Number(b.InventarioNecesario || 0) - Number(a.InventarioNecesario || 0);
  });

  const formatoNumero = (valor) => {
    const numero = Number(valor || 0);
    return numero.toLocaleString("es-GT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const obtenerEstiloFila = (item) => {
    const cobertura = Number(item.Cobertura_Diario_DGUA || 0);

    if (cobertura < 3) {
      return styles.rowDanger;
    }

    if (cobertura < 7) {
      return styles.rowWarning;
    }

    return styles.rowNormal;
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Cobertura Inventario DGUA</h2>

      <button onClick={cargarDatos} style={styles.button}>
        Recargar datos
      </button>

      {loading && <p>Cargando datos...</p>}
      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Código</th>
              <th style={styles.th}>Producto</th>
              <th style={styles.th}>Consumo mensual</th>
              <th style={styles.th}>Consumo diario</th>
              <th style={styles.th}>Inventario DGUA</th>
              <th style={styles.th}>Cobertura días</th>
              <th style={styles.th}>Días pendientes</th>
              <th style={styles.th}>Inventario necesario</th>
            </tr>
          </thead>

          <tbody>
            {dataOrdenada.map((item, index) => (
              <tr key={`${item.ItemCode}-${index}`} style={obtenerEstiloFila(item)}>
                <td style={styles.td}>{item.ItemCode}</td>
                <td style={styles.td}>{item.ItemName}</td>
                <td style={styles.tdNumber}>{formatoNumero(item.CONSUMO_MENSUAL)}</td>
                <td style={styles.tdNumber}>{formatoNumero(item.CONSUMO_DIARIO)}</td>
                <td style={styles.tdNumber}>
                  {formatoNumero(item.InventarioFisicoDGUA)}
                </td>
                <td style={styles.tdNumber}>
                  <strong>{formatoNumero(item.Cobertura_Diario_DGUA)}</strong>
                </td>
                <td style={styles.tdNumber}>
                  {formatoNumero(item.Cobertura_Diaria_Pendiente)}
                </td>
                <td style={styles.tdNumber}>
                  {formatoNumero(item.InventarioNecesario)}
                </td>
              </tr>
            ))}

            {!loading && dataOrdenada.length === 0 && (
              <tr>
                <td style={styles.td} colSpan="8">
                  No hay datos para mostrar.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "24px",
    fontFamily: "Arial, sans-serif",
  },
  title: {
    marginBottom: "16px",
  },
  button: {
    marginBottom: "16px",
    padding: "10px 16px",
    background: "#0d6efd",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  error: {
    color: "red",
    fontWeight: "bold",
  },
  tableContainer: {
    overflow: "auto",
    maxHeight: "80vh",
    border: "1px solid #ddd",
    borderRadius: "8px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
  },
  th: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    background: "#222",
    color: "#fff",
    padding: "10px",
    border: "1px solid #444",
    textAlign: "left",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "8px",
    border: "1px solid #ddd",
  },
  tdNumber: {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  rowDanger: {
    background: "#ffcccc",
    color: "#900",
    fontWeight: "bold",
  },
  rowWarning: {
    background: "#fff3cd",
  },
  rowNormal: {
    background: "#fff",
  },
};